enum AuthenticationStateEnum {
  UNKNOWN = 1,
  LOGGED_IN = 2,
  LOGGED_OFF = 3,
  FORCED_LOGGED_OFF = 4,
}

export default AuthenticationStateEnum;
